module.exports = __webpack_public_path__ + "img/discharging1.d76cc9e5.gif";